import pt from 'prop-types';
import { Component } from 'react';
import {
    DIALOG_PORTAL_CONTAINER_ID,
    isMobile,
    LegacyCommanderContextValue,
    unreliableIsMobileDevice,
    WithBreakpointRange,
} from '@mews-commander/ui';
import { LocalizationSubscribeContext } from '@mews/framework';
import { TimeDialogPicker, TimePicker, withBreakpointRange } from '@optimus-web/core';

interface Props extends WithBreakpointRange {
    value?: string;
    error?: React.ReactNode;
    onChange?: $TSFixMe;
    size?: string;
}

class CommanderTimeStringPickerComponent extends Component<Props> {
    declare context: LegacyCommanderContextValue & LocalizationSubscribeContext;
    static contextTypes = {
        localizationSubscribe: pt.func.isRequired,
        getTimeService: pt.func.isRequired,
    };

    unsubscribe: $TSFixMe;

    componentDidMount() {
        this.unsubscribe = this.context.localizationSubscribe(() => this.forceUpdate());
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {
        const { breakpointRange, ...other } = this.props;

        const isMobileDevice = isMobile(breakpointRange) || unreliableIsMobileDevice();
        const pickerElementProps = {
            ...other,
            getTimeService: this.context.getTimeService,
            autoComplete: 'off',
            portalContainerId: isMobileDevice ? DIALOG_PORTAL_CONTAINER_ID : undefined,
        };

        const OptimusTimePickerElement = isMobileDevice ? TimeDialogPicker : TimePicker;

        return <OptimusTimePickerElement {...pickerElementProps} />;
    }
}

export const TimeStringPicker = withBreakpointRange(CommanderTimeStringPickerComponent);
